import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-configurator",
  "use": "icon-s-configurator-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-configurator\"><path d=\"m11-.155 9.66 5.578v11.154L11 22.155l-9.66-5.578V5.423zm0 2.31L3.339 6.577v8.845L11 19.844l7.66-4.422V6.577zm-.482 4.785a3.21 3.21 0 0 1 3.046-.845c.203.05.274.301.126.45l-1.658 1.657.252 1.514 1.514.252 1.658-1.658a.267.267 0 0 1 .449.123 3.201 3.201 0 0 1-4.132 3.812L8 16l-2.018-2.018 3.777-3.759c-.368-1.117-.125-2.399.76-3.283\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol